import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleLoginModal } from 'platform/site-wide/user-nav/actions';

import { setLoggedInFlow } from '../utils/sessionStorage';

const selectIsLoggedIn = state =>
  Boolean(state?.user?.login?.currentlyLoggedIn);

/**
 * Opens the site-wide VA.gov sign-in modal (ID.me/Login.gov via OAuth) for
 * unauthenticated users. Returns a callback that is a no-op for signed-in
 * users so an authenticated session is never interrupted by the modal.
 *
 * The `va-chatbot` trigger and forced verification mirror the legacy
 * chatbot's login-modal dispatch, which is the sign-in path the chatbot
 * carries forward.
 *
 * Signing in is a full-page redirect, so a flag is used to indicate
 * that a sign-in is in progress.
 *
 * @returns {() => void} showSignInModal
 */
export default function useSignInModal() {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(selectIsLoggedIn);

  return useCallback(() => {
    if (!isLoggedIn) {
      setLoggedInFlow('true');
      dispatch(toggleLoginModal(true, 'va-chatbot', true));
    }
  }, [dispatch, isLoggedIn]);
}
